import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _values from 'lodash/values';
import _isEqual from 'lodash/isEqual';

import { CALENDAR_THEMES } from '../../constants';
import './container.scss';

const Container = ({ children, containerClassName, theme }) => (
  <div
    className={classnames('brzw-calendar-container', 'layout-box l__has-rows', containerClassName, {
      [`brzw-calendar-container--theme-${theme}`]: theme,
      'flyout-full-width-content': !_isEqual(theme, CALENDAR_THEMES.THIRD),
    })}
  >
    {children}
  </div>
);

Container.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  containerClassName: PropTypes.string,
  theme: PropTypes.oneOf(_values(CALENDAR_THEMES)),
};

Container.defaultProps = {
  containerClassName: '',
  theme: CALENDAR_THEMES.PRIMARY,
};

export default Container;
